import { useState } from "react";
import { Box, Typography, Button, Paper, CircularProgress, Alert, Snackbar } from "@mui/material";
import { CloudDownload as CloudDownloadIcon } from "@mui/icons-material";
import DashboardLayout from "@/components/DashboardLayout";
import { exportCsv } from "@/api/patient";

const DataExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const blob = await exportCsv();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${new Date().toISOString().slice(0, 10)}_whik.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setSuccess(true);
    } catch (err: any) {
      setError(err?.message || "Fehler beim Datenexport.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Datenexport
        </Typography>

        <Paper sx={{ p: 3, mt: 3 }}>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Hier können Sie Ihre Patientinnendaten als CSV-Datei herunterladen
            und sichern. Es werden ausschließlich Ihre eigenen Patientinnen
            exportiert. Die exportierte Datei hat dasselbe Format wie die
            CSV-Datei, die über den Datenimport importiert werden kann.
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CloudDownloadIcon />}
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? "Export läuft…" : "CSV-Datei herunterladen"}
          </Button>
        </Paper>
      </Box>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar
        open={success}
        autoHideDuration={4000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" onClose={() => setSuccess(false)}>
          Export erfolgreich – die Datei wurde heruntergeladen.
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

export default DataExport;
